<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    ref="dialog"
    :close-on-click-modal="false"
    class="dialog-dark dialog-include-table"
    :title="$t('lucked.中奖名单')"
    width="454px"
    @open="getWinnerInfo"
  >
    <div>
      <h1 class="lucked-result-title">{{ config.title }}</h1>
      <el-table
        :data="winnerRaffleDetails"
        :height="165"
        class="table-dark table-noborder"
      >
        <el-table-column prop="nickname" :label="$t('lucked.姓名')" width="180px">
        </el-table-column>
        <el-table-column prop="winnerCode" :label="$t('lucked.中奖码')"> </el-table-column>
        <Blank :width="80" :height="68" slot="empty" :text="$t('lucked.暂无数据')" />
      </el-table>
    </div>
    <div slot="footer" class="lucked-footer">
      <el-button
        v-if="!config.needCheck && !isPulishLuckDrawResult"
        :disabled="isPulishLuckDrawResult"
        class="button-mini"
        type="primary"
        size="mini"
        @click="sendWinUserResult('1')"
        >{{$t('lucked.发送中奖结果')}}</el-button
      >
      <span
        v-if="config.needCheck || isPulishLuckDrawResult"
        class="lucked-is-send"
        >{{$t('lucked.结果已发布')}}</span
      >
      <el-button
        :plain="!config.needCheck && !isPulishLuckDrawResult"
        class="button-mini"
        type="primary"
        size="mini"
        @click="reLuck()"
        >{{$t('lucked.重新抽奖')}}</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { Dialog, Table, TableColumn } from "element-ui";
import {
  getRaffleWinUser,
  comfireRaffleResult
} from "@/api/liveRequest/luckDawApi";
import Blank from "@/components/blank";
export default {
  name: "Lucked",
  components: {
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Blank,
  },
  props: {
    config: Object,
    raffleId: String,
  },
  data() {
    return {
      winnerRaffleDetails: [],
      isPulishLuckDrawResult: false,
    };
  },
  methods: {
    /* 获取中奖用户信息 */
    getWinnerInfo() {
      this.isPulishLuckDrawResult = false;
      getRaffleWinUser({ raffleId: this.raffleId }).then((res) => {
        if (res?.code == 200) {
          this.winnerRaffleDetails = res.data.winnerRaffleDetails;
        }else{
          this.winnerRaffleDetails = [];
        }
      });
    },
    /* 发送中奖名单 */
    sendWinUserResult(state) {
      comfireRaffleResult({
        webcastId: this.$route.params.liveId,
        id: this.raffleId,
        state: state,
      }).then((res) => {
        if (state === "0") {
          this.$emit('update:raffleId', res.data.raffleId)
          this.$nextTick(() => {
            this.getWinnerInfo();
            this.isPulishLuckDrawResult = false;
          })
        } else {
          this.isPulishLuckDrawResult = true;
        }
      });
    },
    reLuck() {
      if (this.isPulishLuckDrawResult || this.config.needCheck) {
        this.isPulishLuckDrawResult = false;
        this.$emit("reluck");
      } else {
        this.sendWinUserResult("0");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.lucked-result-title {
  margin-bottom: 24px;
  font-size: 18px;
  color: #ff5f46;
  text-align: center;
}
.lucked-footer {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lucked-is-send {
  position: absolute;
  left: 0;
  font-size: 12px;
  color: #3986ee;
}
</style>
